class Reviews extends HTMLElement {
  constructor() {
    super();
    this.playerContainers = this.querySelectorAll('[data-player-container]');
    this.handlePlayerClick = this.handlePlayerClick.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.attachEventListeners();
    this.initIntersectionObserver();
  }

  attachEventListeners() {
    this.playerContainers?.forEach((container) => {
      container?.addEventListener('click', this.handlePlayerClick);
    });
  }

  initIntersectionObserver() {
    const observerOptions = {
      root: null,
      threshold: 0.1
    };

    this.observer = new IntersectionObserver(this.handleIntersection, observerOptions);

    const videoElements = this.querySelectorAll('[data-video-element]');
    videoElements?.forEach((video) => {
      this.observer?.observe(video);
    });
  }

  handlePlayerClick(event) {
    const currentContainer = event?.currentTarget;
    const videoElement = currentContainer?.querySelector('[data-video-element]');
    const parentItem = currentContainer?.closest('[data-video-item]');

    if (!videoElement) return;

    if (videoElement.paused) {
      videoElement.play();
      parentItem?.classList.add('reviews__item--played');
      parentItem?.style.setProperty('--is-playing-display', 'none');
    } else {
      videoElement.pause();
      parentItem?.style.setProperty('--is-playing-display', 'flex'); 
    }
  }

  handleIntersection(entries) {
    entries?.forEach((entry) => {
      if (!entry?.isIntersecting) {
        const videoElement = entry?.target;
        const parentItem = videoElement?.closest('[data-video-item]');

        if (videoElement && !videoElement.paused) {
          videoElement.pause();
          parentItem?.style.setProperty('--is-playing-display', 'flex');
        }
      }
    });
  }
}

if (!customElements.get('reviews-component')) {
  customElements.define('reviews-component', Reviews);
}